import { UserModel } from "@app/core/models/user/user.model";
import { createAction, props } from "@ngrx/store";


export const getUser = createAction('[User] Get User');
export const setUser = createAction('[User] Set User', props<{data: UserModel}>());
export const NoOp = createAction('NOOP');
export const getUserSuccess = createAction('[User] Get User Success', props<{data: UserModel}>());